<section>

    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" >JobTec</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-center" id="navbarNavAltMarkup">
          <div class="navbar-nav">
            <a class="nav-item nav-link active" routerLink='/gjt'>Home <span class="sr-only">(current)</span></a>
            <a class="nav-item nav-link" routerLink='/users'>Usuario</a>
            <a class="nav-item nav-link" routerLink='/jobs'>Empresa</a>
            <a class="nav-item nav-link cursor" (click)="logout()">Salir</a>
          </div>
        </div>
        <a mat-raised-button matTooltip="{{token}}">
            <div class="material-icons">
               account_circle
            </div>
          </a>
      </nav>

</section>